import { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import brandExperienceUrl from "../assets/blackrednow-multiplatform.jpg";

interface Props {
  onComplete: () => void;
}

export const ANDROID_LAUNCH_INTRO_MS = 3400;

export function AndroidLaunchIntro({ onComplete }: Props) {
  const { t } = useTranslation();
  const completed = useRef(false);
  const finish = useCallback(() => {
    if (completed.current) return;
    completed.current = true;
    onComplete();
  }, [onComplete]);

  useEffect(() => {
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
    const timer = window.setTimeout(finish, reducedMotion ? 700 : ANDROID_LAUNCH_INTRO_MS);
    return () => window.clearTimeout(timer);
  }, [finish]);

  return (
    <section className="android-launch-intro" aria-label={t("androidIntro.ariaLabel")}>
      <div className="android-launch-grid" aria-hidden="true" />
      <div className="android-launch-orbit orbit-one" aria-hidden="true" />
      <div className="android-launch-orbit orbit-two" aria-hidden="true" />

      <div className="android-launch-content">
        <span className="android-launch-kicker">{t("androidIntro.cloud")}</span>
        <div className="android-launch-logo">
          <img src={brandExperienceUrl} alt="BlackRedNow Modern Multiplatform" draggable="false" />
          <span className="android-launch-beam" aria-hidden="true" />
          <span className="android-launch-corner corner-top" aria-hidden="true" />
          <span className="android-launch-corner corner-bottom" aria-hidden="true" />
        </div>
        <div className="android-launch-copy">
          <strong>BLACKRED STUDIO</strong>
          <span>{t("androidIntro.create")} <i /> {t("androidIntro.sync")} <i /> {t("androidIntro.deploy")}</span>
        </div>
        <div className="android-launch-progress" aria-hidden="true"><span /></div>
      </div>

      <button className="android-launch-skip" type="button" onClick={finish}>
        {t("androidIntro.skip")}
      </button>
    </section>
  );
}
